import { http } from "@shared/utils/request";
import type { FetchListOptions, ListResult } from "@shared/types/list";
import type { CurrentUserInfoData } from "@shared/types/user";
import type { SystemProfileDetail, UpdateProfilePayload } from "@shared/views/system/personalCenter/types";
import { mapUserDetailToProfile } from "@shared/views/system/personalCenter/mapUserDetail";
import { toUserListRequestParams } from "@shared/views/system/user/config/filter";
import { mapUserListItemToRow } from "@shared/views/system/user/mapUserListItem";
import type { SystemUserQueryParam, SystemUserRow, UserJumpOnlyApi, UserListApiItem } from "@shared/views/system/user/types";

/** 当前登录用户详情及菜单列表 */
export function fetchCurrentUserInfo(): Promise<CurrentUserInfoData> {
    return http.get<CurrentUserInfoData>("/admin/user/info");
}

/** 修改当前登录用户密码 */
export function changeCurrentPassword(oldPassword: string, newPassword: string): Promise<void> {
    return http.post<void>("/admin/user/changePassword", { oldPassword, newPassword });
}

/** 更新当前登录用户资料（用户名 / 昵称 / 邮箱 / 头像 URL） */
export function updateCurrentProfile(payload: UpdateProfilePayload): Promise<void> {
    return http.post<void>("/admin/user/updateProfile", payload);
}

/** 个人中心：加载资料 */
export async function loadCurrentProfile(): Promise<SystemProfileDetail> {
    const data = await fetchCurrentUserInfo();
    return mapUserDetailToProfile(data.userDetail);
}

interface UserListApiData {
    items: UserListApiItem[];
    total: number;
}

/** Admin 客户企业用户列表（排除主企业；可按企业筛选） */
export function fetchUserList(params: SystemUserQueryParam, options?: FetchListOptions): Promise<ListResult<SystemUserRow>> {
    return http.get<UserListApiData>("/admin/user/list", toUserListRequestParams(params), { signal: options?.signal }).then(res => ({
        list: (res.items || []).map(mapUserListItemToRow),
        total: res.total ?? 0,
    }));
}

/** 签发进入客户端的一次性 ticket */
export function jumpLoginUser(userId: string): Promise<{ ticket: string }> {
    return http.post<{ ticket: string }>("/admin/user/jumpLogin", { userId });
}

export const userJumpOnlyApi: UserJumpOnlyApi = {
    fetchList: fetchUserList,
    jumpLogin: jumpLoginUser,
};
